export default "<div class=\"text-logo\">\n        <img src=\"../../../assets/img/logo.jpeg\"/>\n      </div>"